import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import EscritorioSection from './components/EscritorioSection';
import AreasSection from './components/AreasSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import ComoAtuamosSection from './components/ComoAtuamosSection';
import ContatoSection from './components/ContatoSection';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <EscritorioSection />
      <AreasSection />
      <DiferenciaisSection />
      <ComoAtuamosSection />
      <ContatoSection />
      <Footer />
    </main>
  );
};

export default HomePage;
